/**
 * Localization messages for RoleCardDescription component
 * Following invertedMessages pattern from @saviynt/common
 *
 * Pattern: English default message maps to translation key
 * This allows the English string to serve as both:
 * 1. The lookup key
 * 2. The default fallback if translation is missing
 * 3. Clear documentation for translators
 *
 * NOTE ABOUT TRANSLATION:
 * =======================
 * These are the ONLY strings that need translation. List formatting
 * (commas, "or" connectors within values, and "and" connectors between conditions)
 * is handled automatically by the browser's Intl.ListFormat API based
 * on the user's locale. Translators should NOT translate:
 * - The "or" connector within value lists
 * - The "and" connector between conditions
 * - Commas between values
 * - Punctuation rules for lists
 *
 * These are automatically adapted to each language's grammar rules.
 *
 * WHAT DOES NOT GET TRANSLATED:
 * ==============================
 * - Attribute names from backend (i.e., "city", "department")
 * - Attribute values from backend (i.e., "Chennai", "Manager")
 * These are system identifiers and user data that display as-is.
 */
const invertedMessages = {
  // main wrapper sentence for the entire role description
  'This role is for users whose {description}.':
    'roleRecs.card.description.wrapper',

  // template for individual conditions (e.g., "city is Chennai or Bangalore")
  '{attribute} is {values}': 'roleRecs.card.description.condition',
} as const;

export default invertedMessages;
